module.exports = __webpack_public_path__ + "static/media/img_address.2b4a6356.png";